<template>
  <router-view @cotentLoading="cotentLoading" @showNotification="notifyVue"></router-view>
</template>
<script>
  export default {
    methods: {
      cotentLoading(){
        this.$emit('cotentLoading', false)
      },
      notifyVue(html, color, icon){
        this.$emit(
          'showNotification', html, color, icon
        )   
      }
    }
  }
</script>